import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';

import { Form } from '../../shared/form';
import { HttpErrorHandler } from '../../shared/http-error-handler';

import { ProfileService } from '../../_services/profile.service';

@Component({
  selector: 'app-password-reset-confirm',
  templateUrl: './password-reset-confirm.component.html',
  styleUrls: ['./password-reset-confirm.component.css'],
})
export class PasswordResetConfirmComponent extends Form implements OnInit {
  protected uid: string;
  protected token: string;
  protected new_password: string;
  protected re_new_password: string;

  protected send: boolean;

  constructor(
    private fb: FormBuilder,
    private profileService: ProfileService,
    protected route: ActivatedRoute,
    protected httpErrorHandler: HttpErrorHandler
  ) {
    super(route, httpErrorHandler);
    this.form = fb.group({
      new_password: [''],
      re_new_password: [''],
    });
  }

  ngOnInit() {
    this.getUrlParams();
    this.setFormMode('create');
  }

  protected getUrlParams() {
    this.route.params.forEach((params: Params) => {
      this.uid = params['uid'];
      this.token = params['token'];
    });
  }

  protected onSubmit() {
    this.profileService
      .resetPasswordConfirm({
        uid: this.uid,
        token: this.token,
        new_password: this.new_password,
        re_new_password: this.re_new_password,
      })
      .subscribe(
        (response) => (this.send = true),
        (error) => this.handleError(error)
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/password/password-reset-confirm/password-reset-confirm.component.ts